(function () {

    "use strict";
    function menuleftappController($state, $mdSidenav) {

        var vm = this;

        vm.showMobileMainHeader = true;
        vm.closeSideNavPanel = function () {
            $mdSidenav('left').close();
        };
        vm.changestate = function (newState, stateParams) {
            $state.go(newState, stateParams);
            $mdSidenav('left').close();
        };
    }

    menuleftappController.$inject = ["$state", "$mdSidenav"];

    angular.module("sphforms.main")
        .component("sphformsMenuLeftApp", {
            controller: menuleftappController,
            templateUrl: "modules/main/components/menus/menuleftapp/menuleftapp.template.html"
        });

}());


